import { Component, OnInit, OnDestroy, Input, ChangeDetectorRef } from '@angular/core';
import { DomService } from 'app/components/dom/dom.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ExhitorsService } from 'app/components/exhitors/exhitors.service';
import { UtilsService } from 'app/components/utils/utils.service';
import { ProductsService } from 'app/components/products/products.service';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { ModalYesNoComponent } from 'app/components/modal-yes-no/modal-yes-no.component';
import { NgbActiveModal, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ModalSimpleComponent } from "app/components/modal-simple/modal-simple.component";
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-exhibitor-backoffice-exhibitor-products',
  templateUrl: './exhibitor-backoffice-exhibitor-products.component.html',
  styleUrls: ['./exhibitor-backoffice-exhibitor-products.component.css']
})
export class ExhibitorBackofficeExhibitorProductsComponent implements OnInit, OnDestroy {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  menuItem: string = '';
  id: string = '';

  catalogueName: string | null = '';
  exhibitorId: string | null = '';
  eventName: string | null = '';

  products: Array<any> = [];

  page: number = 1;
  pageSize: number = 10;
  filter: string = '';

  buttonLink: string = '';

  projection: object = {};
  availableLanguages: Array<any> = ["en", "es", "ca"];
  disabled: boolean = false;

  constructor(private domService: DomService, private exhitorsService: ExhitorsService, private activatedRoute: ActivatedRoute,
    private router: Router, public utilsService: UtilsService, private productsService: ProductsService, public catalogueService: CatalogueService,
    private modalService: NgbModal, private translateService: TranslateService, private cdr: ChangeDetectorRef) {
    this.exhibitorId = this.activatedRoute.snapshot.paramMap.get('exhibitorId') || null;
    this.catalogueName = this.activatedRoute.snapshot.paramMap.get('event') || null;
    this.eventName = this.catalogueService.getProperty('eventName')
    this.buttonLink = this.catalogueName + '/exhibitor-backoffice/exhibitors/' + this.exhibitorId + '/product-create'
  }



  getProducts(getProductsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getProducts(getProductsIn)
      .subscribe((data: object) => {
        this.getProductsOk(data);
      },
        error => {
          this.getProductsError(error);
        });

  }

  getProductsOk(data) {
    this.loader.count--;
    this.products = data._embedded.products;
    if (this.products.length === 0) {
      this.disabled = true;
    }
  }

  getProductsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  filterElements() {
    if (!this.filter) {
      return this.products;
    } else {
      return this.products.filter(obj => {
        return this.utilsService._api(obj['translations'], 'name').toLowerCase().includes(this.filter.toLowerCase());
      });
    }
  }

  goTo(product) {
    let url = this.catalogueName + '/exhibitor-backoffice/exhibitors/' + this.exhibitorId + '/products/' + product.id + '/product-detail';
    this.router.navigate([url]);
  }

  goToCreate(url) {
    this.router.navigate([url]);
  }


  togglePublished(product, event) {

    event.stopPropagation();

    let updatePublishedIn = {
      id: product.id,
      newValue: product.published ? false : true
    }

    this.updatePublished(updatePublishedIn, product);

  }


  updatePublished(updatePublishedIn, product) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.productsService.updatePublished(updatePublishedIn)
      .subscribe((data: object) => {
        this.updatePublishedOk(data, product);
      },
        error => {
          this.updatePublishedError(error);
        });

  }

  updatePublishedOk(data, product) {
    this.loader.count--;
    product.published = product.published ? false : true;
  }

  updatePublishedError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

    if (error.code === '000035') {
      const modalRef = this.modalService.open(ModalSimpleComponent);
      modalRef.componentInstance.titleTranslation = 'MODAL_SIMPLE.TITLE_INFORMATION';
      modalRef.componentInstance.modalInformation = alertData.alertMessage;
      modalRef.componentInstance.isHtml = false;
    }

  }

  updateNovelties(updateNoveltiesIn, product) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.productsService.updateNovelties(updateNoveltiesIn)
      .subscribe((data: object) => {
        this.updateNoveltiesOk(data, product);
      },
        error => {
          this.updateNoveltiesError(error);
        });

  }

  updateNoveltiesOk(data, product) {
    this.loader.count--;
    product.novelty = product.novelty ? false : true;
  }

  updateNoveltiesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: 'EXHIBITOR_BACKOFFICE_EXHIBITOR_PRODUCTS.ERRORS.' + error.code
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

    if (error.code === '000004') {
      const modalRef = this.modalService.open(ModalSimpleComponent);
      modalRef.componentInstance.titleTranslation = 'MODAL_SIMPLE.TITLE_INFORMATION';
      modalRef.componentInstance.modalInformation = alertData.alertMessage;
      modalRef.componentInstance.isHtml = false;
    }

  }

  toggleNovelty(product, event) {

    event.stopPropagation();

    let updateNoveltiesIn = {
      eventName: this.catalogueName,
      id: product.id,
      novelty: product.novelty ? false : true
    }

    this.updateNovelties(updateNoveltiesIn, product);

  }

  editProduct(product, event) {

    event.stopPropagation();

    let url = this.catalogueService.getProperty('id') + '/' + this.catalogueName + '/exhibitor-backoffice/exhibitors/' + this.exhibitorId + '/products/' + product.id + '/product-detail-edit';
    this.router.navigate([url]);

  }

  removeProductBtn(product, event) {

    event.stopPropagation();

    const modalRef = this.modalService.open(ModalYesNoComponent);
    modalRef.componentInstance.question = 'MODAL_YES_NO.REMOVE_PRODUCT';

    modalRef.result.then((option) => {

      if (option === 'yes') {

        let removeProductIn = {
          productId: parseInt(product.id)
        }

        this.removeProduct(removeProductIn);

      }

    });

  }

  getProjection(getProjectionIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getProjection(getProjectionIn)
      .subscribe((data: object) => {
        this.getProjectionOk(data);
      },
        error => {
          this.getProjectionError(error);
        });

  }

  getProjectionOk(data) {
    this.loader.count--;
    this.projection = data;
  }

  getProjectionError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  removeProduct(removeProductIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.productsService.removeProduct(removeProductIn)
      .subscribe((data: object) => {
        this.removeProductOk(data);
      },
        error => {
          this.removeProductError(error);
        });

  }

  removeProductOk(data) {

    this.loader.count--;

    let getProductsIn = {
      exhibitorId: this.exhibitorId
    }

    this.getProducts(getProductsIn);


  }

  removeProductError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  translateProducts() {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';
    let allTexts: Array<any> = [];

    const modalRef = this.modalService.open(ModalYesNoComponent);
    modalRef.componentInstance.question = 'MODAL_YES_NO.IA_TRANSLATION';

    modalRef.result.then((option) => {

      if (option === 'yes') {

        let translationRequest = {};
        let currentLanguage = this.translateService.currentLang;

        for (let productPosition = 0; productPosition < this.products.length; productPosition++) {

          let productItem = this.products[productPosition];

          for (let translationPosition = 0; translationPosition < this.products[productPosition]['translations'].length; translationPosition++) {

            let translationItem = this.products[productPosition]['translations'][translationPosition];

            if (translationItem['language'] === this.translateLang(currentLanguage)) {

              allTexts.push(

                {
                  "id": productItem['id'],
                  "text": translationItem['description'],
                  "textType": "description"
                },
                {
                  "id": productItem['id'],
                  "text": translationItem['name'],
                  "textType": "name"
                }
              );


            }

          }


        }
        translationRequest['texts'] = allTexts;
        translationRequest['languageFrom'] = currentLanguage;
        translationRequest['languageTo'] = this.availableLanguages;
        translationRequest['apiVersion'] = "";
        translationRequest['apiKey'] = "";

        let redisData = {
          redisKey: this.catalogueName + '-' + this.exhibitorId + '-ALLPRODUCTS'
        }

        this.catalogueService.getTranslations(translationRequest, redisData.redisKey).subscribe((data: object) => {
          this.getTranslationsOk(data);
        },
          error => {
            this.getTranslationsError(error);
          });

      } else {
        this.loader.count--;
      }
    }).catch((reason) => {
      // Handle modal dismissal (click outside, ESC, etc.)
      this.loader.count--; // Optionally reset loader if canceled
    });

  }


  getTranslationsOk(data) {

    this.loader.count--;

    const saveProductsIn: any[] = [];

    const allExtendedTexts = data.flatMap(item => item.extendedTextResponses || []);
    for (const product of this.products) {

      // Filter entries matching current product ID
      const matchingTexts = allExtendedTexts.filter(
        (et) => et.id.toString() === product.id.toString()
      );

      if (matchingTexts.length === 0) continue;

      const nameTranslations: Record<string, string> = {};
      const descriptionTranslations: Record<string, string> = {};

      for (const entry of matchingTexts) {
        const translatedLang = this.translateLang(entry.to);
        if (!translatedLang) continue;
        if (entry.textType === 'name') {
          nameTranslations[translatedLang] = entry.text;
        } else if (entry.textType === 'description') {
          descriptionTranslations[translatedLang] = entry.text;
        }
      }

      saveProductsIn.push({
        id: product.id,
        nameTranslations: Object.keys(nameTranslations).length > 0 ? nameTranslations : undefined,
        descriptionTranslations: Object.keys(descriptionTranslations).length > 0 ? descriptionTranslations : undefined,
        eventName: this.catalogueService.getProperty('eventName'),
        exhibitorId: product.exhibitorId,
        properties: [],
        hierarchicalProperties: [],
        publicationOrder: product['publicationOrder'],
        videoUrl: product['videoUrl'],
        published: product['published']
      });
    }
    this.saveProducts(saveProductsIn);
  }

  getTranslationsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  translateLang(lang) {

    switch (lang) {
      case 'es':
        return 'es_ES';
        break;
      case 'ca':
        return 'ca_ES';
        break;
      case 'en':
        return 'en_GB';
        break;
      default:
        return '';
        break;
    }

  }

  saveProducts(saveProductsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.productsService.saveProducts(saveProductsIn)
      .subscribe((data: object) => {
        this.saveProductsOk(data);
      },
        error => {
          this.saveProductsError(error);
        });

  }

  saveProductsOk(data) {

    this.loader.count--;

    this.reloadPage();

  }

  saveProductsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }
  reloadPage() {
    window.location.reload();
  }

  ngOnInit() {

    this.domService.addClassToBody('bg-gray');

    let getProductsIn = {
      exhibitorId: this.exhibitorId
    }

    this.getProducts(getProductsIn);

    let getProjectionIn = {
      exhibitorId: this.exhibitorId,
      projection: 'detail'
    };

    this.getProjection(getProjectionIn);

  }

  ngOnDestroy() {
    this.domService.removeClassFromBody('bg-gray');
  }

}
